export enum StateType {
  SUCCESS = 'success',
  DANGER = 'danger',
  WARNING = 'warning',
}
